$(document).ready(function() {

    // Open toggle

    $(".faq-block-heading").on("click", function() {
        console.log("clicked");
        // Check to see if we're open

        if($(this).parent().attr("data-open") != "true") {

          // Show our content w/ a slide

          $(this).parent().children(".faq-block-content").slideDown();

          // Set a data attr indicating its open

          $(this).parent().attr("data-open", "true");

          // Change our icon

          $(this).children("h1").children("i").removeClass("fa-plus");
          $(this).children("h1").children("i").addClass("fa-minus");
        }
        else {
          // Close it

          $(this).parent().children(".faq-block-content").slideUp();
          $(this).parent().attr("data-open", "false");

          // Change our icon

          $(this).children("h1").children("i").removeClass("fa-minus");
          $(this).children("h1").children("i").addClass("fa-plus");
        }
    });

    /* Controls for FAQ Filter */

    $(".faq-filter-select").on("change", function() {
        var filterValue = $(this).val();

        if(filterValue == "all") {
          // Show all items

          $(".faq-item").each(function() {
              $(this).show();
          });
        }
        else {
          $(".faq-item").each(function() {
              if($(this).attr("data-category") == filterValue) {
                $(this).show();
              }
              else {
                $(this).hide();
              }
          });
        }
    });
});
